import firebase from "firebase";

var firebaseConfig = {
    apiKey: "AIzaSyBtCk1x1DuXCcHibtg18i5Il8tZ3UsuIKY",
    authDomain: "todoreactapp-c68b6.firebaseapp.com",
    projectId: "todoreactapp-c68b6",
    storageBucket: "todoreactapp-c68b6.appspot.com",
    messagingSenderId: "375073367504",
    appId: "1:375073367504:web:d1313558d9046374e7c5d5"
};
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

export {
    db
};